import { Injectable } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { MessageCrudService } from "@evomatik/evk-common";
import { EvkSecurityControlDataService } from "@evomatik/evk-seguridad";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { FirmaElectronicaModel } from "../../../../../../diligencia/models/firma-electronica.model";
import { FirmaModel } from "../../../../../../diligencia/models/firma.model";
import { CadenaOriginalService } from "./cadena-original.service";
import { EvkDiligenciaAddFirmaService } from "./evk-diligencia-add-firma.service";

@Injectable({
    providedIn: 'root'
})
export class EvkDiligenciaFinalizarService {

    constructor(
        private securityControlDataService: EvkSecurityControlDataService,
        private addFirmaService: EvkDiligenciaAddFirmaService,
        private cadenaOriginalService: CadenaOriginalService,
        public messageCrudService: MessageCrudService,
        public dialog: MatDialog) {
    }


    validCadenaOriginarRfc(diligencia: any): Observable<any> {
        return this.cadenaOriginalService.getCadenaOriginal(diligencia.id).pipe(map(response => {
            const rfc = this.securityControlDataService.getUsuarioInfo().persona.rfc;
            if (rfc === undefined || rfc === null || rfc.length <= 0) {
                this.messageCrudService.snackbarMessage('El usuario no cuenta con RFC');
                return;
            }
            return {
                hash: 'sha1',
                message: response.cadena,
                encode: 'base64',
                idDiligencia: diligencia.id,
                username: this.securityControlDataService.getUsuarioInfo().username,
                rfc: this.securityControlDataService.getUsuarioInfo().persona.rfc
            };
        }));
    }

    buildDataFirmaE(responseFirma: any, origen: string): any {
        return {
            data: {
                username: this.securityControlDataService.getUsuarioInfo().username,
                nombreCompleto: this.securityControlDataService.getUsuarioInfo().nombreCompleto,
                cadenaOriginal: responseFirma.cadenaOriginal,
                origen: origen,
                selloDigital: responseFirma.firma,
                rfcCertificado: responseFirma.rfc,
                noSerieCertificado: responseFirma.serial,
                nombreServidorPublico: this.securityControlDataService.getUsuarioInfo().nombreCompleto,
                noSerieCertificadoUsuario: responseFirma.serial,
                fechaHoraCertificado: responseFirma.fechaHoraCertificado
            },
            id: ''
        };
    }

    addFirmaToDiligencia(firmaElectronica: any, diligencia: any): Observable<any> {
        return this.addFirmaService.putFirmaElctronica(firmaElectronica, diligencia.id).pipe(
            map(value => {
                this.messageCrudService.snackbarMessage('La firma se agregó a la actuación');
                return this.addFirmaElectronica(diligencia, value.firma.electronica);
            })
        );
    }

    addFirmaElectronica(diligencia: any, electronica: Array<FirmaElectronicaModel>): any {
        if (diligencia.firma != null) {
            diligencia.firma.electronica = electronica;
        } else {
            const firma = new FirmaModel();
            firma.electronica = electronica;
            diligencia.firma = firma;
        }
        return diligencia;
    }
}
